module.exports = __webpack_public_path__ + "img/empty-state-feedbacks.3f70394e.png";